<template>
    <div class="card">
        <div class="card-body">
            <button type="button" v-if="permission.holding_create" @click="addHoldingModal" class="btn btn-primary pull-left mb-3"><i class="fa fa-life-bouy"></i> Add {{this.$route.name}}</button>
            <div class="table-responsive">
            <table class="table table-sm mb-3">
                <thead>
                <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th>
                    <th scope="col">Father's Name</th>
                    <th scope="col">Mobile</th>
                    <th scope="col">Village</th>
                    <th scope="col">Holding No.</th>
                    <th scope="col">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(holding,index) in holdingRegLists.data" :key="index">
                    <td>{{ index+1}}</td>
                    <td>{{ holding.name }}</td>
                    <td>{{ holding.father_name }}</td>
                    <td>{{ holding.mobile }}</td>
                    <td>{{ holding.village_name }}</td>
                    <td>{{ holding.holding_no }}</td>
                    <td>
                        <i v-if="permission.holding_update" @click="editHoldingModal(holding,index)" class="icon-note icons actn"> </i>
                        <i v-if="permission.holding_delete" @click="deleteHoldingModal(index,holding.id)" class="icon-trash icons actn"> </i>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
            <nav v-if="loading==false" aria-label="Page navigation example">
                <pagination :data="holdingRegLists" @pagination-change-page="getHoldingResults" :limit="5"></pagination>
            </nav>
        </div>
        <addHoldingModal ref="add_holding_modal"></addHoldingModal>
        <editHoldingModal ref="edit_holding_modal"></editHoldingModal>
        <Loader v-if="loading"></Loader>
    </div>
</template>

<script>
    import Loader from '../common/Loader'
    import Vue from 'vue';
    import pagination from 'laravel-vue-pagination'
    import VeeValidate from 'vee-validate';
    import addHoldingModal from './addHoldingModal'
    import editHoldingModal from './editHoldingModal'
    Vue.use(VeeValidate);
    import { mapState,mapGetters } from "vuex"
    import { VueEditor } from 'vue2-editor'
    export default {
        name: "HoldingView",
        data(){
            return{
                loading:false,
                permission:''
            }
        },
        computed:{
            ...mapGetters(['holdingRegLists','user_roles'])
        },
        mounted(){
            this.getHoldingResults()
            this.allRole()
            this.getPermission()
        },
        methods:{
            allRole(){
                this.$store.dispatch('ALL_USER_ROLE')
            },
            getPermission(){
                this.$store.dispatch('ALL_USER_ROLE2')
                .then(response=>{
                    this.permission = response.data.permission
                })
            },
            getHoldingResults(page=1){
                var data = {page:page}
                this.$store.dispatch('HOLDING_REG_LIST',data)
            },
            addHoldingModal(){
                this.$refs.add_holding_modal.openModal()
            },
            editHoldingModal(holding_reg,index){
                this.$refs.edit_holding_modal.openModal(holding_reg,index)
            },
            deleteHoldingModal(index,id){
                this.$store.dispatch('DELETE_HOLDING_REG',{index,id})
            }
        },
        components: {
            addHoldingModal,
            editHoldingModal,
            pagination,
            Loader
        }
    }
</script>

<style scoped>
    .actn{
        margin-left: 10px;
        cursor: pointer;
    }
    .table td{ text-transform: lowercase;}
</style>